import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { ApplicationEditLayout, Content } from "core/layouts";
import {
	BaasicFieldDropdown,
	NumericInputField,
} from "core/components";

const FacilityInventoryCountDetailFullEditTemplate = function ({ facilityInventoryCountDetailEditViewStore }) {

	const {
		contentLoading,
		form,
		productStore,
		updateQuantity
	} = facilityInventoryCountDetailEditViewStore;
	return (
		<ApplicationEditLayout store={facilityInventoryCountDetailEditViewStore}>
			<Content loading={contentLoading}>
				<React.Fragment>
					<div className="row">
						<div className="col col-sml-10 col-lrg-8">
							<div className="card card--form card--primary card--med">
								<div className="row">
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<BaasicFieldDropdown field={form.$('productId')} store={productStore} disabled={false} />
									</div>
									<div className="form__group col col-lrg-3 u-mar--bottom--sml">
										<NumericInputField
											// customRef={quantityRef} 
											field={form.$('caseQty')}
											disabled={false}
											onBlur={(e) => {
												updateQuantity(e.target.value, 'caseQty');
											}}
											max={"999.99"}
											min={"0"}
										/>
									</div>
									<div className="form__group col col-lrg-3 u-mar--bottom--sml">
										<NumericInputField
											// customRef={quantityRef} 
											field={form.$('eachQty')}
											disabled={false}
											onBlur={(e) => {
												updateQuantity(e.target.value, 'eachQty');
											}}
											max={"999.99"}
											min={"0"}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			</Content>
		</ApplicationEditLayout>
	)
};

FacilityInventoryCountDetailFullEditTemplate.propTypes = {
	facilityInventoryCountDetailEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

export default defaultTemplate(FacilityInventoryCountDetailFullEditTemplate);